import { __makeTemplateObject } from "tslib";
import { compose, space, color, typography, layout, flexbox, position, background, } from 'styled-system';
import { createComponent } from '../utils';
import { css } from 'styled-components';
export var BoxComponent = createComponent({
    name: 'BoxComponent',
    style: compose(space, color, typography, layout, flexbox, position, background),
});
export var Box = createComponent({
    name: 'Box',
    as: BoxComponent,
    style: function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      flex: 1 1 auto;\n    }\n  "], ["\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      flex: 1 1 auto;\n    }\n  "]))); },
});
var templateObject_1;
//# sourceMappingURL=Box.js.map